import React, { useEffect, useState } from "react"
import getConfig from "next/config"
import axios from "axios"
import { Loader } from "react-feather"
import DatePill from "./DatePill"
import Image from "../../../Image"
import { useFormStore } from "../../ArchitektAufAnfrage/formStore"

const {
  publicRuntimeConfig: { API_URL },
} = getConfig()

const BookingDateField = ({ field, methods, className }) => {
  const [dates, setDates] = useState(null)
  const [employee, setEmployee] = useState(null)
  const [appointmentType, setAppointmentType] = useState(null)

  const { data } = useFormStore((state) => ({
    data: state.data,
  }))

  const selectedEmployee = data?.[field.employee_key]
  const selectedAppointmentType = data?.[field.appointment_type_key]

  useEffect(() => {
    if (selectedEmployee) {
      setEmployee(JSON.parse(selectedEmployee))
    }
    if (selectedAppointmentType) {
      setAppointmentType(JSON.parse(selectedAppointmentType))
    }
  }, [selectedEmployee, selectedAppointmentType])

  useEffect(() => {
    if (employee && appointmentType) {
      const getDates = async () => {
        return await axios.post(`${API_URL}/acuity/dates`, {
          calendarId: employee.employee_calendar_id,
          appointmentTypeId: appointmentType.id,
        })
      }

      getDates()
        .then((res) => {
          setDates(
            Object.entries(res.data).sort(([kwA], [kwB]) => {
              return kwA - kwB
            })
          )
        })
        .catch((e) => console.log(e))
    }
  }, [employee, appointmentType])

  if (!selectedEmployee) return null

  if (!dates) {
    return (
      <div className="mx-auto w-fit">
        <Loader className="mx-auto h-8 w-8 motion-safe:animate-spin" />
        <span>Lade Daten..</span>
      </div>
    )
  }

  const { employee_image, employee_job, title, employee_expertise } = employee

  return (
    <div>
      <div className="mb-3 font-semibold text-body">Ihr Termin mit:</div>

      <div className="flex gap-4 mb-10">
        <div>
          <div className="w-[88px] aspect-square rounded-full bg-brand-turquoise-800 overflow-hidden p-1">
            <div className="relative w-full h-full rounded-full overflow-hidden">
              {employee_image && (
                <Image
                  alt={employee_image?.alt}
                  src={employee_image?.permalink}
                  fill
                  style={{
                    objectFit: "cover",
                    objectPosition: `${employee_image?.focus_css || "center"}`,
                  }}
                />
              )}
            </div>
          </div>
        </div>

        <div className="flex-grow">
          <div className="font-semibold text-body">{title}</div>
          <div>{employee_job}</div>
          <div className="font-body-small">{employee_expertise}</div>
        </div>
      </div>

      {!!dates.length > 0 && (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8">
          {dates.map(([kw, days]) => (
            <div key={kw}>
              <div className="font-semibold mb-2">KW {kw}</div>
              {days.map((date) => (
                <DatePill
                  key={date.date}
                  name={field.name}
                  methods={methods}
                  date={date}
                />
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default BookingDateField
